import React, { Component } from "react";
import { Card, Button, Table, Input, Typography } from "antd";

import { connect } from "react-redux";
import {
  req_page_ams_alumniSituationAnalysis,
  req_downloadfile_ams_alumniSituationAnalysis,
} from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole, getSchoolAcademicYear } from "../../utils/dataUtil";
//import { formateDate } from '../../utils/dateUtil'
//import storageUtils from '../../utils/storageUtils'

const { Text } = Typography;

class AlumniSituationAnalysis extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    userLevel: "NORMAL",
    loading: false,
    items: [],
    item: {},
    // 分頁參數
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "YearGrade",
    searchValue: getSchoolAcademicYear() - 1,
    filterStatus: "",

    domnloadFile: "",
    isShowModal: false,
  };

  // 基礎通用參數 //////////////////////////////////////////////
  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true });
    const result = await req_page_ams_alumniSituationAnalysis(
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_ams_alumniSituationAnalysis(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "表4-10";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "畢業學年度",
        dataIndex: "YearGrade",
        key: "YearGrade",
        width: 60,
        fixed: "left",
      },
      {
        title: "學院",
        dataIndex: "CollegeName",
        key: "CollegeName",
        width: 60,
        fixed: "left",
      },
      {
        title: "系所",
        dataIndex: "DepartmentName",
        key: "DepartmentName",
        width: 100,
        fixed: "left",
      },
      {
        title: "部別",
        dataIndex: "Division",
        key: "Division",
        width: 35,
        fixed: "left",
      },
      {
        title: "學制",
        dataIndex: "EducationalSystem",
        key: "EducationalSystem",
        width: 35,
        fixed: "left",
      },
      {
        title: "班級類別",
        dataIndex: "ClassCategory",
        key: "ClassCategory",
        width: 45,
        fixed: "left",
      },
      {
        title: "升學",
        key: "ContinueStudy",
        children: [
          {
            title: "男",
            dataIndex: "ContinueStudyBoys",
            key: "ContinueStudyBoys",
            width: 40,
          },
          {
            title: "女",
            dataIndex: "ContinueStudyGirls",
            key: "ContinueStudyGirls",
            width: 40,
          },
        ],
      },
      {
        title: "就業",
        key: "Working",
        children: [
          {
            title: "男",
            dataIndex: "WorkingBoys",
            key: "WorkingBoys",
            width: 40,
          },
          {
            title: "女",
            dataIndex: "WorkingGirls",
            key: "WorkingGirls",
            width: 40,
          },
        ],
      },
      {
        title: "服兵役",
        key: "Military",
        children: [
          {
            title: "男",
            dataIndex: "MilitaryBoys",
            key: "MilitaryBoys",
            width: 40,
          },
          {
            title: "女",
            dataIndex: "MilitaryGirls",
            key: "MilitaryGirls",
            width: 40,
          },
        ],
      },
      {
        title: "留學",
        key: "OverseasStudy",
        children: [
          {
            title: "男",
            dataIndex: "OverseasStudyBoys",
            key: "OverseasStudyBoys",
            width: 40,
          },
          {
            title: "女",
            dataIndex: "OverseasStudyGirls",
            key: "OverseasStudyGirls",
            width: 40,
          },
        ],
      },
      {
        title: "其他(含待業)",
        key: "Other",
        children: [
          {
            title: "男",
            dataIndex: "OtherBoys",
            key: "OtherBoys",
            width: 40,
          },
          {
            title: "女",
            dataIndex: "OtherGirls",
            key: "OtherGirls",
            width: 40,
          },
        ],
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  /////////////////////////////////////////////////////////////

  render() {
    const { loading, items, pagination, searchValue } = this.state;
    const title = (
      <span>
        <Input
          placeholder="畢業學年度"
          style={{ width: 150, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i> 查詢
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_download()}>
          <i className="fas fa-cloud-download-alt element-hidden"></i> 下載
        </Button>{" "}
        <Text mark>請務必與[表4-1 畢業人數資料表]核對人數是否相符</Text>
      </span>
    );
    return (
      <Card title={title}>
        <Table
          columns={this.columns}
          dataSource={items}
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AlumniSituationAnalysis);
